import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import FormattedDayMonth from '@/shared/components/FormattedDayMonth';
import FormattedListValue from '@/shared/components/FormattedListValue';
import AddressChange from '@/modules/relations/audit/components/AddressChange';
import AddressInput from '@/shared/components/input/AddressInput';

const messages = defineMessages({
  BankAccount: 'Bank account',
  Name: 'Name',
  Address: 'Address',
  LegalForm: 'Legal form',
  FiscalYearEnd: 'End of fiscal year',
  Link: 'Linked person/entity',
});

const RelationImportModelDetail = ({ document }) => {
  if (!document.recognitionMeta) return null;
  const data =
    typeof document.recognitionMeta === 'string'
      ? JSON.parse(document.recognitionMeta)
      : document.recognitionMeta;
  console.log('Data:', data);
  return (
    <div className="margin10B">
      <div>
        <label>
          <FormattedMessage {...messages.Name} />: {data.name}
        </label>
      </div>
      {data.address && (
        <div>
          <label>
            <FormattedMessage {...messages.Address} />: {data.address.street1} {data.address.number}{' '}
            {data.address.box || ''}, {data.address.zipCode} {data.address.city}
          </label>
        </div>
      )}
      <div>
        <label>
          <FormattedMessage {...messages.LegalForm} />: {data.legalFormDescription}
        </label>
      </div>
      {data.fiscalYearEnd && (
        <div>
          <label>
            <FormattedMessage {...messages.FiscalYearEnd} />:{' '}
            <FormattedDayMonth value={data.fiscalYearEnd} />
          </label>
        </div>
      )}
      {(data.links || []).map(acc => (
        <div>
          <label>
            <FormattedMessage {...messages.Link} />:{' '}
            <FormattedListValue list="companyownerposition" id={acc.companyowner?.position} />:{' '}
            {acc.name}
          </label>
        </div>
      ))}
      {(data.bankAccounts || []).map(acc => (
        <div>
          <label>
            <FormattedMessage {...messages.BankAccount} />: {acc.bankAccountNumber} ({acc.bic}){' '}
            {acc.remark}
          </label>
        </div>
      ))}
    </div>
  );
};

RelationImportModelDetail.propTypes = {
  document: PropTypes.shape({}).isRequired,
};

export default RelationImportModelDetail;
